/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/filter.js ***!
  \**************************/
  function _closeDrawer() {
    const drawer = document.getElementById('collection-filter-drawer');
    if (drawer) {
      drawer.setAttribute("aria-hidden", "true");
    }
    document.documentElement.classList.remove('no-scroll');
    const pageOverlay = document.querySelector('.PageOverlay');
    if (pageOverlay) {
      pageOverlay.classList.remove('is-visible');
    }
  }
  
  function _openDrawer() {
    const drawer = document.getElementById('collection-filter-drawer');
    if (drawer) {
      drawer.setAttribute("aria-hidden", "false");
    }
    document.documentElement.classList.add('no-scroll');
    const pageOverlay = document.querySelector('.PageOverlay');
    if (pageOverlay) {
      pageOverlay.classList.add('is-visible');
    }
  }

function nodeListToArray(nodeList, filter) {
  var items = [];

  for (var i = 0; i !== nodeList.length; ++i) {
    if (!filter || nodeList[i].matches(filter)) {
      items.push(nodeList[i]);
    }
  }

  return items;
}

var temporaryTags = [];

const filterElement = document.querySelector('.class_for_filter');
if (filterElement) {
  var settings = JSON.parse(filterElement.getAttribute('data-section-settings'));
  var currentTags = settings['currentTags'];
  var currentSortBy = settings['sortBy'];
}

function _updateActiveTags() {
  nodeListToArray(document.querySelectorAll('.CollectionFilters [data-tag]')).forEach(function (item) {
    // IE11 and lower does not support classList.toggle...
    if (temporaryTags.includes(item.getAttribute('data-tag'))) {
      item.classList.add('is-active');
      item.parentNode.classList.add('is-selected'); // For the case of "ListItem"
    } else {
      item.classList.remove('is-active');
      item.parentNode.classList.remove('is-selected'); // For the case of "ListItem"
    }
  });
}

function _reloadProducts() {
  const pageOverlay = document.querySelector('.PageOverlay');
  if (pageOverlay) {
    pageOverlay.classList.add('is-visible');
  }
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  const filterElement = document.querySelector('.CollectionToolbar__Item--filter');


  if (filterElement) {
    var filterElementCount = filterElement.querySelector('span');

    if (filterElementCount) {
      filterElement.removeChild(filterElementCount);
    }

    if (currentTags.length === 0) {
      filterElement.classList.add('Text--subdued');
    } else {
      filterElement.classList.remove('Text--subdued');
      const subdued = filterElement.querySelector('.Text--subdued');
      if (subdued) {
        subdued.innerHTML = '(' + currentTags.length + ')';
      } else {
        filterElement.innerHTML += '<span class="Text--subdued">(' + currentTags.length + ')</span>';
      }
    }
  } // We also rewrite the URL if browser supports it


  var tags = currentTags.length > 0 ? currentTags.join('+') : '';
  var newUrl = window.location.protocol + '//' + window.location.host + settings['collectionUrl'] + '/' + tags + '?sort_by=' + currentSortBy;
  window.history.pushState({
    path: newUrl
  }, '', newUrl);
  var formData = new FormData();
  formData.append('view', 'ajax');
  formData.append('sort_by', currentSortBy);
  fetch(location.pathname + '?view=ajax&sort_by=' + currentSortBy, {
    credentials: 'same-origin',
    method: 'GET'
  }).then(function (response) {
    response.text().then(function (content) {
      var tempElement = document.createElement('div');
      tempElement.className = "temporary_div";
      tempElement.innerHTML = content;

      if (tempElement.querySelector('.collection-grid') != null) {
        document.querySelector('.collection-grid').innerHTML = tempElement.querySelector('.collection-grid').innerHTML;

        if (document.querySelector('.pagination') != null) {
          document.querySelector('.pagination').innerHTML = tempElement.querySelector('.pagination') != null ? tempElement.querySelector('.pagination').innerHTML : '';
        }

        const countElement = document.querySelector('.collection-filter__item--count');
        if (countElement) {
          countElement.innerHTML = tempElement.querySelector('.collection-filter__item--count').innerHTML;
        }

        if (typeof window.tgInitReviewsRatingSnippet === 'function') {
          window.tgInitReviewsRatingSnippet();
        }

        tempElement.remove();
        document.querySelector('.PageOverlay').classList.remove('is-visible');
      }
    });
  });
}

function _commit() {
  if (currentTags.sort().join(',') !== temporaryTags.sort().join(',')) {
    currentTags = temporaryTags.slice();

    _reloadProducts();
  }

  nodeListToArray(document.querySelectorAll('[data-action="reset-tags"]')).forEach(function (resetButton) {
    resetButton.style.display = currentTags.length === 0 ? 'none' : 'block';
  });
}

function _applyTags() {
  _updateActiveTags();

  _commit();

  _closeDrawer();
}

function _resetTags() {
  temporaryTags = []; // We simply remove all tags

  _applyTags();
}

function _transmitEventToButton(event) {
  var parentNode = event.target.parentNode;
  parentNode.querySelector('.checkbox_filter').click();
}

function _toggleTag(event) {
  var element = event.target;

  if (element.classList.contains('is-active')) {
    temporaryTags.splice(temporaryTags.indexOf(element.getAttribute('data-tag')), 1); // Delete the tag if already active
  } else {
    /** to activate multiple filters inside a group (to uncomment if you want to have ono filter by group)  */
    var activeSibling = element.closest('.Collapsible').querySelector('.is-active');

    if (activeSibling) {
      temporaryTags.splice(temporaryTags.indexOf(activeSibling.getAttribute('data-tag')), 1);
    }

    temporaryTags.push(element.getAttribute('data-tag')); // Add if not previously active
  }

  _updateActiveTags(); // If we have the mode set as "sidebar" and that we are on desktop, we auto-commit


  if (settings['filterPosition'] === 'sidebar') {
    _commit();
  }
}

function _toggleCollapsible(event, target) {
  // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
  target = event.target.parentNode;
  var parentCollapsible = target.closest('.Collapsible');
  isOpen = false;

  if (target.getAttribute('aria-expanded') === 'true') {
    isOpen = true;
    target = event.target.parentNode;
  } else {
    if (target.querySelector('.Collapsible__Button') != null && (target.querySelector('.Collapsible__Button').classList.contains('Button_sidebar') || window.innerWidth < 767)) {
      if (target.querySelector('.Collapsible__Button').getAttribute('aria-expanded') === 'true') {
        isOpen = true;
        target = target.querySelector('.Collapsible__Button');
      }
    }
  }

  if (isOpen) {
    _close(parentCollapsible, target);
  } else {
    _open(parentCollapsible, target);
  } // We make sure to close any siblings collapsible as well
  // getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
  //   return _close(collapsibleToClose);
  // });


  event.preventDefault();
}

function _close(collapsible) {
  var toggleButton = collapsible.querySelector('.Collapsible__Button'),
      collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

  if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
    return; // It's already closed
  }

  toggleButton.setAttribute('aria-expanded', 'false');
  collapsibleInner.style.overflow = 'hidden';
  slideUp(collapsibleInner);
}

function slideUp(element) {
  element.style.height = element.scrollHeight + 'px'; // Force previous height to allow CSS transition

  element.offsetHeight; // Force redraw

  element.style.height = 0;
}

function _open(collapsible) {
  var toggleButton = collapsible.querySelector('.Collapsible__Button');
  collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

  if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
    return; // It's already open
  }

  toggleButton.setAttribute('aria-expanded', 'true');
  collapsibleInner.style.overflow = 'visible';
  collapsibleInner.style.height = 'auto';
  slideDown(collapsibleInner);
}

function slideDown(element) {
  if (element.style.height === 'auto') {
    return;
  }
}

function getSiblings(element, filter) {
  var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var siblings = [];
  var currentElement = element; // Do the previous first

  while (currentElement = currentElement.previousElementSibling) {
    if (!filter || currentElement.matches(filter)) {
      siblings.push(currentElement);
    }
  }

  if (includeSelf) {
    siblings.push(element);
  } // Then the next side


  currentElement = element;

  while (currentElement = currentElement.nextElementSibling) {
    if (!filter || currentElement.matches(filter)) {
      siblings.push(currentElement);
    }
  }

  return siblings;
}

document.querySelectorAll(".ButtonGroup [data-action='apply-tags']").forEach(button => {
  button.addEventListener('click', _applyTags);
});

document.querySelectorAll(".ButtonGroup [data-action='reset-tags'], .CollectionFilters [data-action='reset-tags']").forEach(button => {
  button.addEventListener('click', _resetTags);
});

document.querySelectorAll(".Linklist [data-action='toggle-tag']").forEach(link => {
  link.addEventListener('click', _toggleTag);
});

document.querySelectorAll(".filter_color_swatch_name").forEach(swatch => {
  swatch.addEventListener('click', _transmitEventToButton);
  swatch.addEventListener('mouseenter', () => {
    swatch.style.cursor = "pointer";
  });
});

const closeDrawerButton = document.querySelector(".Drawer__Header [data-action='close-drawer']");
if (closeDrawerButton) {
  closeDrawerButton.addEventListener('click', () => {
    _closeDrawer();
    document.querySelector('.collection-filter__btn')?.classList.remove('is-active');
    document.querySelector('#CollectionInlineFilterWrap .filter-wrapper')?.classList.remove('is-active');
    document.documentElement.classList.remove('lock-scroll');
  });
}

const openDrawerButton = document.querySelector(".collection-filter [data-action='open-drawer']");
if (openDrawerButton) {
  openDrawerButton.addEventListener('click', () => {
    _openDrawer();
    document.querySelector('.collection-filter__btn')?.classList.add('is-active');
    document.querySelector('#CollectionInlineFilterWrap .filter-wrapper')?.classList.add('is-active');
  });
}

document.querySelectorAll(".Collapsible [data-action='toggle-collapsible']").forEach(button => {
  button.addEventListener('click', _toggleCollapsible);
});

// Expand all elements by default (after loading)
document.querySelectorAll('.CollectionFilters .Collapsible__Button').forEach(button => {
  button.setAttribute('aria-expanded', 'true');
});

document.querySelectorAll('.CollectionFilters .Collapsible__Inner').forEach(inner => {
  inner.style.height = 'auto';
  inner.style.overflow = 'visible';
});

const firstDrawerButton = document.querySelector('.Drawer__Main .Collapsible__Button');
if (firstDrawerButton) {
  firstDrawerButton.setAttribute('aria-expanded', 'true');
}

const firstDrawerInner = document.querySelector('.Drawer__Main .Collapsible__Inner');
if (firstDrawerInner) {
  firstDrawerInner.style.height = 'auto';
  firstDrawerInner.style.overflow = 'visible';
}

/******/ })()
;